import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myReduxProxy } from '../../../api/_common/reduxProxy.connected';
import { myCallsheetApi } from '../../../api/callsheet/callsheet.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myBookingService } from '../BookingService/BookingService.connected';
import { createCallsheetService } from './CallsheetService.impl';

export const myCallsheetService = createCallsheetService({
  api: myCallsheetApi,
  queryClient,
  reduxProxy: myReduxProxy,
  services: {
    errorService: myErrorService,
    messageService: myMessageService,
    bookingService: myBookingService
  }
});
